import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import PermissionsPopup from '../containers/Permissions-popup';
import ProvisionPopup from '../containers/Provision-popup';
import CollectionsChange from '../components/Collection-change';
import CategoriesMenu from '../components/Categories-menu';
import CategoriesMenuTemp from '../components/Categories-menu-temp';
import {isExperiment} from '../config';

class Popups extends React.Component {
  // todo remove categories menu temp when RedirectToOneAppMarket is merged and redirects are added
  render() {
    return (
      <div className="popups">
        {isExperiment('appMarketNoHeader', this.props.experiments) && this.props.market !== 'standalone' ? <CategoriesMenu/> : null}
        {this.props.market === 'standalone' ? <CategoriesMenuTemp/> : null}
        {this.props.popup.type === 'collections' ? <CollectionsChange/> : null}
        {this.props.popup.type === 'permissions' ? <PermissionsPopup/> : null}
        {this.props.popup.type === 'provision' ? <ProvisionPopup/> : null}
      </div>
    );
  }

  static propTypes = {
    popup: PropTypes.object,
    market: PropTypes.string,
    experiments: PropTypes.object,
    isMarket: PropTypes.func,
    isExp: PropTypes.func
  };
}

function mapStateToProps(state) {
  return {
    popup: state.popup,
    market: state.mode.market,
    experiments: state.mode.experiments
  };
}

export default connect(mapStateToProps)(Popups);



// WEBPACK FOOTER //
// ./containers/Popups.js